export const BASIC_MODAL = {
    ALERT: 'alert',
    CONFIRM: 'confirm',
    REMOVE: 'remove',
};
export const MESSAGE_MODAL_TYPE = {
    /** 경고 메시지 (취소 버튼 없음) */
    WARNING: 'WARNING',
    /** 경고 메시지 (취소 버튼 있음) */
    WARNING_CANCEL: 'WARNING_CANCEL',
    /** 위험한 동작일 때 확인 모달 (ex 삭제) */
    DANGER_CONFIRMATION: 'DANGER_CONFIRMATION',
    /** 일반 확인 모달 */
    CONFIRMATION: 'CONFIRMATION',
};
export const CONTENT_MODAL_SIZE_TYPE = {
    /** width: 392px */
    SMALL: 'SMALL',
    /** width: 432px */
    MEDIUM: 'MEDIUM',
    /** width: 628px */
    LARGE: 'LARGE',
    /** width: 960px */
    XLARGE: 'XLARGE',
};
export const CONTENT_TEXT_ALIGN_TYPE = {
    /** 내부 컨텐츠 좌측 정렬 */
    LEFT: 'left',
    /** 내부 컨텐츠 중앙 정렬 */
    CENTER: 'center',
};
export const MOBILE_MODAL_TYPE = {
    /** 알림 모달 */
    ALERT: 'alert',
    /** 경고 모달 */
    WARN: 'warn',
    /** 확인 모달 */
    CONFIRM: 'confirm',
};
export const INFO_NOTIFICATION_MODAL_TYPE = {
    /** Info 모달 */
    INFO: 'info',
    /** 에러 모달 */
    ERROR: 'error',
    /** 성공 모달 */
    SUCCESS: 'success',
    /** 확인 모달 */
    CONFIRM: 'confirm',
};
